module.exports = __webpack_public_path__ + "static/img/synthe5.928f54b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/synthe5.png
// module id = j9hn
// module chunks = 2